module.exports = __webpack_public_path__ + "static/conv-6f3516af13c47cdda620af66cc13f1dd.svg";